import { render } from "./Menu.vue?vue&type=template&id=dab7d4a0&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=dab7d4a0&scoped=true&lang=css"

import exportComponent from "C:\\projetos\\andamento-da-obra\\client-EN\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dab7d4a0"]])

export default __exports__